<template>
	<!-- <el-header>
		<el-menu background-color="#00c292" text-color="#FFFFFF" active-text-color="#FFFFFF" mode="horizontal">
			<div class="fl title">{{this.$project.projectName}}</div>
			<div class="fr logout" style="display:flex;">
				<el-menu-item index="3">
					<div>{{this.$storage.get('role')}} {{this.$storage.get('adminName')}}</div>
				</el-menu-item>
				<el-menu-item @click="onLogout" index="2">
					<div>退出登录</div>
				</el-menu-item>
			</div>
		</el-menu>
	</el-header> -->
	<div class="navbar" :style="{background:heads.headBgColor,height:heads.headHeight,boxShadow:heads.headBoxShadow,lineHeight:heads.headHeight}">
		<div class="title-menu" :style="{justifyContent:heads.headTitleStyle=='1'?'flex-start':'center'}">
			<!-- 侧边栏折叠按钮 -->
			<div class="hamburger-wrapper" @click="toggleSidebar">
				<i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" class="hamburger"></i>
			</div>
			<el-image v-if="heads.headTitleImg" class="title-img" :style="{width:heads.headTitleImgWidth,height:heads.headTitleImgHeight,boxShadow:heads.headTitleImgBoxShadow,borderRadius:heads.headTitleImgBorderRadius}" :src="heads.headTitleImgUrl" fit="cover"></el-image>
			<div class="title-name" :style="{color:heads.headFontColor,fontSize:heads.headFontSize}">{{this.$project.projectName}}</div>
		</div>
		<div class="right-menu">
			<div class="user-info" :style="{color:heads.headUserInfoFontColor,fontSize:heads.headUserInfoFontSize}">{{this.$storage.get('role')}} {{this.$storage.get('adminName')}}</div>
			<div class="logout" :style="{color:heads.headLogoutFontColor,fontSize:heads.headLogoutFontSize}" @click="onLogout">退出登录</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				ruleForm: {},
				user: {},
				isCollapse: false, // 侧边栏折叠状态
				heads: {"headLogoutFontHoverColor":"#409EFF","headFontSize":"20px","headUserInfoFontColor":"#606266","headBoxShadow":"0 1px 4px rgba(0,21,41,.08)","headTitleImgHeight":"32px","headLogoutFontHoverBgColor":"rgba(64,158,255,0.1)","headFontColor":"#303133","headTitleImg":false,"headHeight":"50px","headTitleImgBorderRadius":"4px","headTitleImgUrl":"http://codegen.caihongy.cn/20201021/cc7d45d9c8164b58b18351764eba9be1.jpg","headBgColor":"#fff","headTitleImgBoxShadow":"none","headLogoutFontColor":"#606266","headUserInfoFontSize":"14px","headTitleImgWidth":"32px","headTitleStyle":"1","headLogoutFontSize":"14px"},
			};
		},
		created() {
			this.setHeaderStyle()
		},
		mounted() {
			let sessionTable = this.$storage.get("sessionTable")
			this.$http({
				url: sessionTable + '/session',
				method: "get"
			}).then(({
				data
			}) => {
				if (data && data.code === 0) {
					this.user = data.data;
					this.$storage.set('userid',data.data.id);
				} else {
					let message = this.$message
					message.error(data.msg);
				}
			});
		},
		methods: {
			// 切换侧边栏折叠状态
			toggleSidebar() {
				this.isCollapse = !this.isCollapse;
				// 通过事件总线通知侧边栏组件
				this.$bus.$emit('toggleSidebar', this.isCollapse);
			},
			onLogout() {
				let storage = this.$storage
				let router = this.$router
				storage.clear()
				router.replace({
					name: "login"
				});
			},
      			onIndexTap(){
      				window.location.href = `${this.$base.indexUrl}`
    			},
			setHeaderStyle() {
			  this.$nextTick(()=>{
			    document.querySelectorAll('.navbar .right-menu .logout').forEach(el=>{
			      el.addEventListener("mouseenter", e => {
			        e.stopPropagation()
			        el.style.backgroundColor = this.heads.headLogoutFontHoverBgColor
					el.style.color = this.heads.headLogoutFontHoverColor
			      })
			      el.addEventListener("mouseleave", e => {
			        e.stopPropagation()
			        el.style.backgroundColor = "transparent"
					el.style.color = this.heads.headLogoutFontColor
			      })
			    })
			  })
			},
		}
	};
</script>


<style lang="scss" scoped>
	.navbar {
		height: 50px;
		line-height: 50px;
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		background-color: #fff;
		position: relative;
		z-index: 111;
		box-shadow: 0 1px 4px rgba(0,21,41,.08);
		border-bottom: 1px solid #e6e6e6;
		
		// 若依风格 - 汉堡菜单按钮
		.hamburger-wrapper {
			float: left;
			cursor: pointer;
			padding: 0 15px;
			margin-right: 10px;
			
			.hamburger {
				font-size: 20px;
				color: #303133;
				transition: all 0.3s;
				
				&:hover {
					color: #409EFF;
				}
			}
		}
		
		.right-menu {
			position: absolute;
			right: 20px;
			top: 0;
			height: 100%;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			z-index: 111;
			
			.user-info {
				font-size: 14px;
				color: #606266;
				padding: 0 12px;
			}
			
			.logout {
				font-size: 14px;
				color: #606266;
				padding: 0 12px;
				cursor: pointer;
				transition: all 0.3s;
				
				&:hover {
					color: #409EFF;
				}
			}
			
		}
		
		.title-menu {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: 100%;
			height: 100%;
			
			.title-img {
				width: 32px;
				height: 32px;
				border-radius: 4px;
				margin-right: 12px;
			}
			
			.title-name {
				font-size: 18px;
				color: #303133;
				font-weight: 600;
			}
		}
	}
</style>
